import _ from 'lodash'

export function normalizeComponentLabel(value) {
  if (_.isEmpty(value)) {
    return ''
  }
  let result = value.replaceAll('oid_', '')
  result = result.replaceAll('dt', 'Data')
  result = result.replaceAll('_', ' ')
  const split = result.split(' ')
  return split
    .map((word) => {
      return _.capitalize(word)
    })
    .join(' ')
}
